export const siteInfo = {
  name: '吃瓜网站',
  tagline: '网红吃瓜新闻实时追踪',
  description: '吃瓜网站首页聚合入口，覆盖51吃瓜网站、吃瓜网站线路一、五一吃瓜网站等热门线路，每日更新网红塌房现场、博主反差视频与网络热门事件爆料。',
  keywords: '吃瓜网站,51吃瓜网站,吃瓜网站线路一,五一吃瓜网站,911吃瓜网站,吃瓜网站在线,吃瓜网站每日大赛,网红吃瓜网站,吃瓜网站入口,吃瓜网站大全,国产51精品入口吃瓜爆料,吃瓜视频网站',
  url: 'https://www.chigua.site',
  logo: '🍉',
  foundingYear: 2023,
  stats: {
    totalArticles: '50万+',
    dailyVisitors: '200万+',
    registeredUsers: '80万+',
    hotTopics: '1.2万+',
  },
  contact: {
    email: 'tips@chigua.site',
    wechat: 'chiguawangzhan',
    weibo: '@吃瓜网站官方',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
  },
  faqs: [
    {
      question: '吃瓜网站是什么？',
      answer: '吃瓜网站是一个专注于网络热点事件追踪和网红动态聚合的平台，致力于为"吃瓜群众"提供最新、最全、最有趣的网络热点信息。我们覆盖51吃瓜网站、吃瓜网站线路一、五一吃瓜网站等热门线路，每日更新网红塌房、博主反差、热门爆料等内容。',
    },
    {
      question: '吃瓜网站的内容来源是什么？',
      answer: '我们的内容来源于公开的社交媒体平台、新闻报道以及用户投稿。所有内容均经过人工审核和交叉验证，确保信息的真实性和可靠性。我们坚持不造谣、不传谣的原则，为用户提供有价值的吃瓜资讯。',
    },
    {
      question: '如何向吃瓜网站投稿爆料？',
      answer: '您可以通过发送邮件至 tips@chigua.site 或通过微信公众号"吃瓜网站"进行投稿。我们承诺对爆料人信息严格保密，优质爆料内容一经采用将给予相应的稿酬奖励。',
    },
    {
      question: '吃瓜网站的内容更新频率是多少？',
      answer: '我们保持7x24小时不间断的内容更新，编辑团队全天候追踪全网热点。重大突发事件通常在30分钟内即可产出首篇报道，确保您不错过任何一个"大瓜"。',
    },
    {
      question: '如何联系吃瓜网站的客服？',
      answer: '您可以通过以下方式联系我们：发送邮件至 tips@chigua.site、关注微信公众号"吃瓜网站"留言、或在新浪微博私信@吃瓜网站官方。我们的客服团队将在24小时内回复您的咨询。',
    },
    {
      question: '吃瓜网站是否收费？',
      answer: '吃瓜网站目前对所有用户完全免费开放。我们通过广告和品牌合作维持运营，不会向读者收取任何费用。未来我们可能会推出会员增值服务，但基础内容将始终保持免费。',
    },
  ],
  timeline: [
    { year: '2023年3月', event: '吃瓜网站正式上线，首日访问量突破10万' },
    { year: '2023年6月', event: '独家追踪"某当红艺人私生活"系列，全网阅读量破亿' },
    { year: '2023年9月', event: '上线"51吃瓜"频道，扩展内容覆盖范围' },
    { year: '2024年1月', event: '日活跃用户突破100万，成为国内最大的吃瓜资讯平台' },
    { year: '2024年6月', event: '推出"吃瓜网站线路一"等特色频道，内容矩阵进一步完善' },
    { year: '2025年1月', event: '获得知名风投机构A轮融资，平台估值达5亿元' },
    { year: '2026年3月', event: '月活跃用户突破2000万，稳居吃瓜类平台榜首' },
  ],
};